/* jshint ignore:start */

var MapsManager = (function () {
    var instance;



    function init() {

        var USE_CLUSTERS = false;
        var _markerCluster = null;

        var _itemsMap = [];
        var _markers = [];
        var _markersMobile = [];
        var _info_window;
        var _mc_options = '';
        var _initZoom = 4;
        var _map;
        var _mapMobile;

      
        var _locationActives = [];
        var _catsActives = [];
        var _servicesActives = [];

        // var geocoder = new google.maps.Geocoder();
        var geocoder = null;

        var activeFilterClass = 'btn-filter--selected';

        function getHtmlMap(itemMap) {
            var html = '<div class="contact-popup"><div class="contact-popup__info">';

            if (itemMap.reference_time) {
                html += '<time class="ref-list__grid-item-date mb-0">' + itemMap.reference_time + '</time>';
            }

            html += '<p class="ref-list__grid-item-who">' + itemMap.ref_type + '</p>'
            html += '<p class="ref-list__grid-item-where">' + itemMap.name + '</p>';
            html += '<p class="ref-list__grid-item-type">' + itemMap.catServHtml + '</p>';
            html += '</div></div>';

            return html;
        }

        function findMarkerById(id) {
            for (var i = 0; i < _itemsMap.length; i++) {
                if (_itemsMap[i].id === id) {
                    return i;
                }
            }

            return -1;
        }

        function showAddress(val, changeMap) {
            var ref = this;

            _block_map = true;

            // comprobar que es un zip code:
            var ercp = /(^([0-9]{4,5})|^)$/;

            var components = '';
            if ((ercp.test(val))) {
                components = " España";
            }

            _info_window.close();

            geocoder.geocode({
                'address': decodeURI(val + components),

            }, function (results, status) {
                //console.log(google.maps.GeocoderStatus);

                if (status == google.maps.GeocoderStatus.OK && results.length) {

                    if (changeMap) {
                        // console.log(results);

                        _map.setCenter(results[0].geometry.location);

                        if (typeof results[0].types != "undefined") {
                            if (results[0].types.indexOf("country") != -1) {
                                _map.setZoom(6);
                            }
                            else
                                _map.setZoom(9);
                        } else {
                            _map.setZoom(9);
                        }

                        var coordenadas = _map.getBounds();
                        var p1 = coordenadas.getSouthWest();
                        var p2 = coordenadas.getNorthEast();

                        _p1lng = p1.lng();
                        _p1lat = p1.lat();
                        _p2lng = p2.lng();
                        _p2lat = p2.lat();

                        instance.updateShops();
                    }
                } else {
                    _filterSearch = val ? val : null;

                }
            });
        }

        function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
            var R = 6371; // Radius of the earth in km
            var dLat = deg2rad(lat2 - lat1);  // deg2rad below
            var dLon = deg2rad(lon2 - lon1);
            var a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2)
                ;
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            var d = R * c; // Distance in km
            return d;
        }

        function compareDistance(a, b) {
            return a.distance < b.distance ? -1 : (a.distance > b.distance ? 1 : 0);
        }

        function orderShopsByNearly() {
            _itemsMap.sort(compareDistance);
        }

        function deg2rad(deg) {
            return deg * (Math.PI / 180)
        }

        function setMapOnAll(map) {
            for (var i = 0; i < _markers.length; i++) {
                _markers[i].setMap(map);
            }
        }

        function setMapOnAllMobile(map) {
            for (var i = 0; i < _markersMobile.length; i++) {
                _markersMobile[i].setMap(map);
            }
        }

        function resetMapOnAll(map) {
            for (var i = 0; i < _markers.length; i++) {
                _markers[i].setMap(null);
            }
        }

        function hasServicesActiveItem(item) {
            if (_servicesActives.length == 0) {
                return true;
            }

            var serviceTmp;
            var hasService = false;
            for (var i = 0; i < _servicesActives.length; i++) {
                serviceTmp = parseInt(_servicesActives[i],10);
                if (item.services.indexOf(serviceTmp) >= 0) {
                    hasService = true;
                }
            }

            return hasService;
        }

        function hasLocationActiveItem(item) {
            if (_locationActives.length == 0) {
                return true;
            }

            var hasLocation = false;
            for (var i = 0; i < _locationActives.length; i++) {
                if (item.location.indexOf(_locationActives[i]) >= 0) {
                    hasLocation = true;
                }
            }

            return hasLocation;
        }

        function centerMapToMarkers(isMobile) {
            if (_markers.length == 0) {
                return;
            }

            var tmpMap = isMobile ? _mapMobile : _map;

            var bounds = new google.maps.LatLngBounds();
            for (i = 0; i < _markers.length; i++) {
                bounds.extend(_markers[i].getPosition());
            }

            tmpMap.setCenter(bounds.getCenter());
            tmpMap.fitBounds(bounds);
            tmpMap.setZoom(tmpMap.getZoom() - 1);

            if (tmpMap.getZoom() > 15) {
                tmpMap.setZoom(15);
            }

            if (_markers.length == 1) {
                tmpMap.setZoom(15);
                // tmpMap.setMaxZoom(15);
                tmpMap.fitBounds(bounds);
                // tmpMap.setMaxZoom(Null)
            }

        }

        function zoomToPoint(idPoint) {
            var index = findMarkerById(idPoint);

            // console.log('items', _itemsMap);

            if (index < 0) {
                return;
            }

            zoomToMarker(_itemsMap[index], false);
        }

        function zoomToMarker(itemMap, isMobile) {
            // console.log('marker', itemMap);

            var tmpMap = isMobile ? _mapMobile : _map;

            var latlng = new google.maps.LatLng(itemMap.ref_google.lat, itemMap.ref_google.lng);

            // var position = {lat: floatVal(itemMap.ref_google.lat), lng: itemMap.ref_google.lng};
            tmpMap.setCenter(latlng);
            tmpMap.setZoom(15);

            if (isMobile) {
                marker = itemMap.markerMobile;
            } else {
                marker = itemMap.marker;
            }

            // console.log(marker);

            _info_window.setOptions({ maxWidth: 500 });
            _info_window.setContent(marker.html);
            _info_window.open(tmpMap, marker);

            // console.log(_info_window);

            // _info_window.setOptions({ maxWidth: 500 });
            // _info_window.setContent(marker.html);
            // _info_window.open(tmpMap, marker);


            // tmpMap.setCenter(bounds.getCenter());
        }


        return {
            checkAndInit: function () {
                this.checkGoogle();
            },

            initListener: function () {

            },

            loadDependecies: function() {
                var ref = this;

                var script;
                var eleHead = document.getElementsByTagName("head")[0]

                script = document.createElement("script")
                script.type = "text/javascript";
                script.src = "/wp-content/themes/nts/static/markerclusterer/markerclusterer.js";
                script.onload = function () {
                    //do stuff with the script
                    ref.loadDependeciesClustererManager();
                };
                eleHead.appendChild(script);
            },

            loadDependeciesClustererManager: function()
            {
                var ref = this;

                var script;
                var eleHead = document.getElementsByTagName("head")[0]

                script = document.createElement("script")
                script.type = "text/javascript";
                script.src = "/wp-content/themes/nts/static/markerclusterer/markermanager1_1.js";
                script.onload = function () {
                    //do stuff with the script
                    ref.initMaps();
                };
                eleHead.appendChild(script);

                // this.initMaps();
            },

            checkGoogle: function () {
                // console.log('google ', google);
                if (!google || typeof google === 'undefined') {
                    this.initListener();
                } else {
                    if (USE_CLUSTERS) {
                        this.loadDependecies();
                    } else {
                        this.initMaps();
                    }

                    this.geocoder = new google.maps.Geocoder();
                }
            },

            initCategory: function () {
                
                var referenceManager = new ReferencesManager.getInstance();
                var categoryId = referenceManager.getCurrentCategory();
                this.setCategory(categoryId);
                this.initMaps();
            },

            loadItemsMap: function ($map) {
                var i;
                var itemMap;
                var numRefs = CUSTOM_DATA.referencesData.length;
                for (i = 0; i < numRefs; i++) {
                    itemMap = CUSTOM_DATA.referencesData[i];
                    itemMap.idx = i;
                    itemMap.active = false;

                    _itemsMap.push(itemMap);
                }

                // console.log('MAP...', $map);

                this.initMap($map);
            },


            initMaps: function () {
                var ref = this;

                if (jQuery('.js-googleMap').length) {

                    jQuery('.js-googleMap').each(function () {
                        ref.loadItemsMap(jQuery(this));
                    });
                }
            },

            initMap: function ($map) {
                var ref = this;

                _initZoom = $map.data('zoom');
                var latitude = $map.data('latitude');
                var longitude = $map.data('longitude');
                var icon = $map.data('icon');

                var idMap = $map.attr('id');

                // console.log('idMap', idMap);

                var tmpMap;

                var isMobile = false;
                if (idMap == 'mapReferencesMobile') {
                    isMobile = true;
                    _mapMobile = new google.maps.Map(document.getElementById(idMap), {
                        center: { lat: latitude, lng: longitude },
                        scrollwheel: false,
                        zoom: _initZoom,
                        zoomControl: true,
                        zoomControlOptions: {
                            position: google.maps.ControlPosition.LEFT_CENTER,
                        },
                        scaleControl: true,
                        streetViewControl: true,
                        streetViewControlOptions: {
                            position: google.maps.ControlPosition.LEFT_TOP,
                        },
                        fullscreenControl: true,
                    });

                    tmpMap = _mapMobile;
                } else {
                    _map = new google.maps.Map(document.getElementById(idMap), {
                        center: { lat: latitude, lng: longitude },
                        scrollwheel: false,
                        zoom: _initZoom
                    });

                    tmpMap = _map;
                }                

                _info_window = new google.maps.InfoWindow();

                var itemMap;
                for (var i = 0; i < _itemsMap.length; i++) {
                    itemMap = _itemsMap[i];

                    if (itemMap.active) {
                        this.initMarker(itemMap, isMobile);
                    }
                }

                google.maps.event.addListener(_info_window, 'domready', function () {

                    // Reference to the DIV that wraps the bottom of infowindow
                    var iwOuter = jQuery('.gm-style-iw');

                    /* Since this div is in a position prior to .gm-div style-iw.
                     * We use jQuery and create a iwBackground variable,
                     * and took advantage of the existing reference .gm-style-iw for the previous div with .prev().
                     */
                    var iwBackground = iwOuter.prev();

                    // background shadow DIV
                    iwBackground.children(':nth-child(2)').css({ 'background': '#FFFFFF', 'box-shadow': '0 2px 20px 0 rgba(0,0,0,0.20)' });

                    // Moves the shadow of the arrow to the left.
                    iwBackground.children(':nth-child(1)').attr('style', function (i, s) { return s + 'left: 0px !important; top: 0px !important; box-shadow:none; background: transparent; border: 0; ' });

                    // Moves the arrow to the left.
                    iwBackground.children(':nth-child(3)').attr('style', function (i, s) { return s + 'left: 0px !important; top: 0px !important; box-shadow:none; background: transparent; ' });

                    // Changes the desired tail shadow color.
                    iwBackground.children(':nth-child(3)').find('div').children().css({ 'box-shadow': 'none', 'z-index': '0', 'background': 'transparent', 'border': '0', 'display': 'none !important' });

                });

                google.maps.event.addListener(tmpMap, 'zoom_changed', function () {
                    // ref.updateItemsMap();
                });
                google.maps.event.addListener(tmpMap, 'idle', function () {
                    // ref.updateItemsMap();
                });

                if (USE_CLUSTERS) {
                    this.initMarkerCluster(isMobile);
                }

            },

            initMarker: function (itemMap, isMobile) {
                var ref = this;
                var latlng = new google.maps.LatLng(itemMap.ref_google.lat, itemMap.ref_google.lng);

                var tmpMap = (isMobile ? _mapMobile : _map);
                var marker = new google.maps.Marker({
                    position: latlng,
                    map: tmpMap,
                    title: itemMap.ref_type + ' ' + itemMap.name,
                    icon: itemMap.icon,
                    idx: itemMap.idx,
                    html: getHtmlMap(itemMap)
                });


                marker.addListener('click', function () {
                    const zoom = parseInt(itemMap.zoom) > 0 ? itemMap.zoom : 9;
                    const zoomMap = tmpMap.getZoom();
                    if (zoomMap < zoom) {
                        // console.log('ZOOM map cambiando...', zoomMap,);
                        tmpMap.setZoom(zoom);
                    }

                    _info_window.setOptions({ maxWidth: 500 });
                    _info_window.setContent(this.html);
                    _info_window.open(tmpMap, this);

                    tmpMap.setCenter(marker.getPosition());

                    // if (isMobile) {
                    //     _mapMobile.setCenter(marker.getPosition());
                    // } else {
                    //     _map.setCenter(marker.getPosition());
                    // }
                });

                if (isMobile) {
                    _itemsMap[itemMap.idx].markerMobile = marker;    
                } else {
                    _itemsMap[itemMap.idx].marker = marker;
                }

                _markers.push(marker);
            },

            resetMap: function () {
                var i;
                var item;
                var numItems = _itemsMap.length;

                for (i = 0; i < numItems; i++) {
                    item = _itemsMap[i];
                    item.active = false;
                }
            },


            updateItemsMapByFilter: function () {
                var j;
                var categories;
                var numCats;
                var item;
                var numItems = _itemsMap.length;

                for (i = 0; i < numItems; i++) {
                    item = _itemsMap[i];
                    categories = item.categories;

                    numCats = categories.length;
                    for (j = 0; j < numCats; j++) {
                        if (_catsActives.indexOf(categories[j]) >= 0
                            && hasServicesActiveItem(item)
                            && hasLocationActiveItem(item)) {
                            item.active = true;
                        } else {
                            item.active = false;
                        }
                    }
                }

                this.renderList();
            },

            renderList: function () {
                var itemMap;

                setMapOnAll(null);                

                _markers = [];

                for (var i = 0; i < _itemsMap.length; i++) {
                    itemMap = _itemsMap[i];

                    if (itemMap.active) {
                        this.initMarker(itemMap, false);
                    }
                }

                this.centerVisibleMarkers(false);

                if (USE_CLUSTERS) {
                    this.initMarkerCluster();
                }

                this.renderListMobile();
            },

            renderListMobile: function() {
                var itemMap;

                setMapOnAllMobile(null);                

                _markersMobile = [];

                for (var i = 0; i < _itemsMap.length; i++) {
                    itemMap = _itemsMap[i];

                    if (itemMap.active) {
                        this.initMarker(itemMap, true);
                    }
                }

                this.centerVisibleMarkers(true);
            },

            setCategories: function (categories) {
                _catsActives = categories
            },

            setLocations: function (locations) {
                _locationActives = locations;
            },

            setServices: function (services) {
                _servicesActives = services;
            },

            centerVisibleMarkers: function (isMobile) {
                centerMapToMarkers(isMobile);
            },

            goToPoint: function(idPoint) {
                zoomToPoint(idPoint);
            },

            initMarkerCluster: function(isMobile) {
                var tmpMap = isMobile ? _mapMobile : _map; 

                if (!USE_CLUSTERS) {
                    return;
                }
                
                var clusterStyles = [
                    {
                        textColor: '#ffffff',
                        url: '/wp-content/themes/nts/dist/images/maps/new-images/circle-m.png',
                        height: 49,
                        width: 33
                    },
                    {
                        textColor: 'white',
                        url: '/wp-content/themes/nts/dist/images/maps/new-images/circle-l.png',
                        height: 52,
                        width: 39
                    },
                    {
                        textColor: 'white',
                        url: '/wp-content/themes/nts/dist/images/maps/new-images/circle-xl.png',
                        height: 60,
                        width: 44
                    }
                ];
                _mc_options = {
                    styles: clusterStyles
                };
                _markerCluster = new MarkerClusterer(tmpMap, _markers, _mc_options);
            },

            resetMarkerCluster: function(){
                if (USE_CLUSTERS) {
                    _markerCluster.clearMarkers();
                    /* _markerCluster.addMarkers(_markers);*/
                }
            },

            addMarkersCluster: function() {
                _markerCluster.addMarkers(_markers);
            }


        };
    }


    return {

        getInstance: function () {

            if (!instance) {
                instance = init();
            }

            return instance;
        }

    };


})();

/* jshint ignore:end */